import DatePicker from 'vue2-datepicker';
import commonHelper from '@/app/utility/common.helper.utility';
import appStrings from '../../../../../../../utility/string.utility';
export default {
  name: 'escalation',
  components: {
    DatePicker
  },
  props: ['editMode', 'masterAgreementApprovalStatus'],
  data() {
    return {
      vsetCode: null,
      uomClassObj: null,
      specIndex: null,
      showValueSetModal: false,
      parent_value_set_id: null,
      areaType: null,
      setTimeVsetCode: null,
      gridData: [
        {
          lease_escalation: null,
          lease_escalation_uom_vset: null,
          lease_escalation_uom_vset_meaning: null,
          lease_master_agreement_escalation_id: 0,
          lease_master_agreement_hdr_id: null,
          period_from: null,
          period_to: null,
          active: true,
          period: null,
          escalation_type_vset: null,
          escalation_type_vset_meaning: null
        }
      ],
      gridFields: [
        {
          key: 'add',
          stickyColumn: true
        },
        {
          key: 'remove',
          stickyColumn: true
        },
        {
          key: 'active',
          stickyColumn: true
        },
        {
          key: 'lease_escalation_uom_vset_meaning',
          label: 'UOM'
        },
        {
          key: 'period'
        },
        {
          key: 'escalation_type_vset_meaning',
          label: 'Escalation Type'
        },
        {
          key: 'lease_escalation',
          label: 'Escalation'
        },
        {
          key: 'period_from'
        },
        {
          key: 'period_to'
        }
      ]
    };
  },
  mounted() {
    this.eventBus.$on('escalation', leaseMasterAgreementHdrId => {
      if (leaseMasterAgreementHdrId) {
        this.getDetails(leaseMasterAgreementHdrId);
      }
    });
  },
  methods: {
    getDetails(leaseMasterAgreementHdrId) {
      const payload = {
        tabName: 'escalation',
        leaseMasterAgreementHdrId: leaseMasterAgreementHdrId
      };
      this.loader = true;
      this.$store
        .dispatch('leases/getLeaseMasterAgreementDataById', payload)
        .then(resp => {
          this.loader = false;
          if (
            resp.status === 200 &&
            resp.data.data.length > 0 &&
            this.gridData[0].lease_master_agreement_escalation_id === 0
          ) {
            this.gridData = resp.data.data;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    addNewRow() {
      if (this.editMode) {
        this.gridData.push({
          lease_escalation: null,
          lease_escalation_uom_vset: null,
          lease_escalation_uom_vset_meaning: null,
          lease_master_agreement_escalation_id: 0,
          lease_master_agreement_hdr_id: null,
          period_from: null,
          period_to: null,
          active: true,
          period: null,
          escalation_type_vset: null,
          escalation_type_vset_meaning: null
        });
      }
    },
    removeRow(index) {
      if (this.editMode) {
        this.gridData.splice(index, 1);
      }
    },
    opendDependentUom(vsetCode, index) {
      const payload = {
        valueSetName: vsetCode,
        dependentVariable: {
          user_id: this.$store.state.auth.userId,
          res_id: this.$store.state.shared.responsibilityId
        }
      };
      this.$store
        .dispatch('shared/getCommonVSetData', payload)
        .then(response => {
          this.loader = false;
          this.uomClassObj = null;
          if (response.status === 200) {
            const findTimeObj = response.data.data.page.find(
              vsetData => vsetData.value_code === 'TIME'
            );
            if (findTimeObj) {
              this.uomClassObj = findTimeObj;
              this.openValueSetModal('UOM', index);
            }
          }
        });
    },
    selectedvalueSet(item) {
      if (this.vsetCode === 'UOM') {
        this.gridData[this.specIndex].lease_escalation_uom_vset =
          item.value_code;
        this.gridData[this.specIndex].lease_escalation_uom_vset_meaning =
          item.value_meaning;
      } else if (
        this.vsetCode === appStrings.VALUESETTYPE.ESCALATION_TYPE_VSET
      ) {
        this.gridData[this.specIndex].escalation_type_vset = item.value_code;
        this.gridData[this.specIndex].escalation_type_vset_meaning =
          item.value_meaning;
      }
      this.gridData = JSON.parse(JSON.stringify(this.gridData));
      this.showValueSetModal = false;
    },
    openValueSetModal(vsetCode, index) {
      this.vsetCode = vsetCode;
      this.specIndex = index;
      this.showValueSetModal = true;
      this.parent_value_set_id = null;
      if (this.uomClassObj) {
        this.parent_value_set_id = this.uomClassObj.value_set_dtl_id;
      }
      if (this.vsetCode === appStrings.VALUESETTYPE.ESCALATION_TYPE_VSET) {
        this.parent_value_set_id = null;
      }
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    checkUncheckRadio(specIndex) {
      this.gridData.forEach((element, index) => {
        return (element.active = index === specIndex ? true : false);
      });
    },
    setDate(dateRange, index) {
      this.gridData[index].period_from_to = commonHelper.setFutureDate(
        dateRange
      );
    },
    startDateIndex(index) {
      this.specIndex = index;
      this.gridData[index].period_to = null;
    },
    endDateIndex(index) {
      this.specIndex = index;
    },
    disabledDates(date) {
      return commonHelper.disabledDates(
        date,
        this.gridData[this.specIndex].period_from
      );
    },
    clearVsetValues(segment, index) {
      if (segment === 'ESCALATION_TYPE_VSET') {
        this.gridData[index].escalation_type_vset = null;
        this.gridData[index].escalation_type_vset_meaning = null;
      } else if (segment === 'UOM_CLASS') {
        this.gridData[index].lease_escalation_uom_vset = null;
        this.gridData[index].lease_escalation_uom_vset_meaning = null;
      }
    }
  },
  beforeDestroy() {
    this.eventBus.$off('escalation');
  }
};
